import React from 'react'
import MaterialSymbol from '../material-symbol'

const Person = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="person" {...props} />
))

Person.displayName = 'Person'

export default Person
